import { RootState } from '../store'

export const selectLog = (state: RootState) => state.logForm
